import './Header.scss';
import logoVinoseleccion from '../assets/images/logo-min.png';

function Header() {
  return (

    <div>
      <header className="header__container">
        <a href="https://www.vinoseleccion.com">
          <img className="main__logo" src={logoVinoseleccion} alt="Vinoselección"></img>
        </a>
        <ul className="menu__container">
          <li className="menu__item"><a href="https://www.vinoseleccion.com/vinos">Vinos</a></li>
          <li className="menu__item"><a href="https://www.vinoseleccion.com/nuestras-selecciones">Suscripciones</a></li>
          <li className="menu__item"><a href="https://www.vinoseleccion.com/accesorios">Accesorios</a></li>
          <li className="menu__item"><a href="https://www.vinoseleccion.com/hoteles-enoturismo">Enoturismo</a></li>
          <li className="menu__item"><a href="https://www.vinoseleccion.com/regala-vino-2021">Regala Vino</a></li>
          <li className="menu__item"><a href="https://www.vinoseleccion.com">Contacto</a></li>
        </ul>

        <div className="responsive-menu__container">
        <input type="checkbox"></input>
          <nav>
            <ul>
              <li className="menu__item"><a href="https://www.vinoseleccion.com/vinos">Vinos</a></li>
              <li className="menu__item"><a href="https://www.vinoseleccion.com/nuestras-selecciones">Suscripciones</a></li>
              <li className="menu__item"><a href="https://www.vinoseleccion.com/accesorios">Accesorios</a></li>
              <li className="menu__item"><a href="https://www.vinoseleccion.com/hoteles-enoturismo">Enoturismo</a></li>
              <li className="menu__item"><a href="https://vinoseleccion.com/regala-vino-2021">Regala Vino</a></li>
              <li className="menu__item"><a href="https://www.vinoseleccion.com">Contacto</a></li>
            </ul>
          </nav>
        </div>

      </header>
    </div>
  )
}

export default Header;
